import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomePageModule } from './home/home.module';
import { SubscriptionPageModule } from './subscriptions/subscriptions.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ''
  },
  {
    loadChildren: () => SubscriptionPageModule,
    path: 'subscriptions'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class StorePageRoutingModule {}
